import { useDispatch } from 'react-redux';

import useResource from 'app/hooks/useResource';

import {
  catalogs as resource
} from 'app/resources';

import {
  getCatalogs,
  setCatalogParams
} from 'app/actions/catalogs';

import {
  createCatalog,
  updateCatalog,
  destroyCatalogs
} from 'app/services/catalogs';

const useCatalogs = () => {
  return useResource({
    resource,
    getResource: getCatalogs,
    createResource: createCatalog,
    updateResource: updateCatalog,
    destroyResource: destroyCatalogs,
    setResourceParams: setCatalogParams
  });
}

export default useCatalogs;

